module.exports = __webpack_public_path__ + "img/case-icon-6.f18a5886.png";